'use client';

import { c as _c } from "react/compiler-runtime";
import { Badge, Skeleton } from '@common/components';
import { useState } from 'react';
import { Image } from '@/components/client';
import { useCheckWelloApp } from '@/hooks/useCheckWelloApp';
import { CUSTOM_SCHEME } from '@/modules/wello-app';
import { formatPrice } from '@/utils/formatPrice';
import { useCoupangRecommend } from '../_hooks/useCoupangRecommend';
export const CoupangRecommendSection = () => {
  const $ = _c(28);
  const {
    products,
    isLoading
  } = useCoupangRecommend();
  const {
    isWelloApp
  } = useCheckWelloApp();
  const [randomSeed] = useState(_temp);
  if (isLoading) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <h2 className="font-700 text-Gray-900 typo-h7">쿠팡 추천 상품</h2>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Skeleton className="aspect-square w-full rounded-xsmall" />;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="flex w-full flex-col gap-16 px-20">{t0}<div className="flex flex-col gap-12 rounded-small border border-Gray-100 bg-Gray-white p-16">{t1}<div className="flex flex-col gap-8"><Skeleton className="h-20 w-3/4 rounded-xsmall" /><Skeleton className="w-80 rounded-xsmall" typo="body1" /></div></div></div>;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  if (products.length === 0) {
    return null;
  }
  const product = products[Math.floor(randomSeed * products.length)];
  let t0;
  if ($[3] !== isWelloApp || $[4] !== product.clickUrl) {
    t0 = () => {
      if (isWelloApp) {
        window.location.href = `${CUSTOM_SCHEME.EXTERNAL_PREFIX}${product.clickUrl}`;
      }
    };
    $[3] = isWelloApp;
    $[4] = product.clickUrl;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  const handleClickProduct = t0;
  let t1;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h2 className="font-700 text-Gray-900 typo-h7">쿠팡 추천 상품</h2>;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== product.productImage || $[8] !== product.productName) {
    t2 = <div className="relative aspect-square w-full overflow-hidden rounded-xsmall"><Image src={product.productImage} alt={product.productName} fill={true} sizes="(max-width: 599px) 100vw, 400px" className="object-cover" /></div>;
    $[7] = product.productImage;
    $[8] = product.productName;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== product.productName) {
    t3 = <p className="line-clamp-2 font-500 text-Gray-900 typo-body2">{product.productName}</p>;
    $[10] = product.productName;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== product.productPrice) {
    t4 = formatPrice(product.productPrice);
    $[12] = product.productPrice;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t4) {
    t5 = <span className="font-700 text-Gray-900 typo-body1">{t4}</span>;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== product.isRocket) {
    t6 = product.isRocket ? <Badge className="bg-B-50 text-B-500">로켓배송</Badge> : null;
    $[16] = product.isRocket;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t5 || $[19] !== t6) {
    t7 = <div className="flex items-center gap-8">{t5}{t6}</div>;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t3 || $[22] !== t7) {
    t8 = <div className="flex flex-col gap-8">{t3}{t7}</div>;
    $[21] = t3;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== handleClickProduct || $[25] !== t2 || $[26] !== t8) {
    t9 = <div className="flex w-full flex-col gap-16 px-20">{t1}<button onClick={handleClickProduct} className="flex flex-col gap-12 rounded-small border border-Gray-100 bg-Gray-white p-16 text-left transition-colors focus-visible:border-Gray-300 focus-visible:bg-Gray-50 active:bg-Gray-50 xl:hover:border-Gray-300 xl:hover:bg-Gray-50">{t2}{t8}</button></div>;
    $[24] = handleClickProduct;
    $[25] = t2;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  return t9;
};
function _temp() {
  return Math.random();
}